import config from '@/config';
import systemActions from "../actions/system";

const initialState = {
  currentLangCode: config.DEFAULT_LANGUAGE,
  units: [],
  toolbarTitle: "",
  organizations: [],
  storages: [],
  mainStorage: null,
  showChangeOrganizationModal: false,
  langCodes: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case systemActions.ToggleOrganizationModal.TRIGGER: {
      return { ...state, showChangeOrganizationModal: action.payload };
    }
    case systemActions.SetToolbarTitle.TRIGGER: {
      return { ...state, toolbarTitle: action.payload };
    }
    case systemActions.ChangeLanguage.TRIGGER: {
      return { ...state, currentLangCode: action.payload };
    }
    case systemActions.GetUnits.SUCCESS: {
      return { ...state, units: action.payload };
    }
    case systemActions.GetOrganizations.SUCCESS: {
      return { ...state, organizations: action.payload };
    }
    case systemActions.GetStorages.SUCCESS: {
      const isMain = action.payload.find((s) => s.is_main === 1);
      return {
        ...state,
        storages: action.payload,
        mainStorage: isMain ? isMain : action.payload[0],
      };
    }
    case systemActions.GetPaymentTypes.SUCCESS: {
      return { ...state, paymentTypes: action.payload };
    }
    case systemActions.SetMainStorage.TRIGGER: {
      return {
        ...state,
        mainStorage: action.payload,
      };
    }
    case systemActions.SetLangCodes.TRIGGER: {
      return { ...state, langCodes: action.payload };
    }
    default:
      return state;
  }
};
